import { Component } from 'react';

export default class BasicStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      store: props.getStore(),
    };

    this.getValidatorData = this.getValidatorData.bind(this);
    this.isValidated = this.isValidated.bind(this);
  }

  isValidated() {
  }

  getValidatorData() {
  }

  /**
   * Save the form object
   * @param {*} object 
   * @param {*} newObject 
   */
  save(object, newObject) {
    Object.keys(object).map((key, index) => {
      var val = object[key];

      if (Array.isArray(val)) {
        newObject[key] = val;
      }
      else if (typeof(val) === "object") {
        newObject[key] = {};
        this.save(val, newObject[key]);
      } else {
        if (this.refs[key] !== undefined) {
          newObject[key] = this.refs[key].value;
        }
      }
    });

  }
}


// WEBPACK FOOTER //
// ./src/components/Steps/BasicStep.js